import { render, staticRenderFns } from "./InvoiceForm.vue?vue&type=template&id=87855ffa&scoped=true&"
import script from "./InvoiceForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceForm.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceForm.vue?vue&type=style&index=0&id=87855ffa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87855ffa",
  null
  
)

export default component.exports